
document.addEventListener('livewire:init', () => {
    let isLoading = false;
    const trigger = document.querySelector('[data-ref="trigger.infinity_scroll.complexes"]');
    const loader = document.querySelector('[data-ref="infinity-scroll-loader.complexes"]');
    if (!trigger) return;

    function loadNext() {
        if (isLoading) return;
        isLoading = true;
        if (loader) loader.style.display = '';
        Livewire.dispatch('uploadComplexes');
    }

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                loadNext();
            }
        });
    }, { rootMargin: '500px' });

    observer.observe(trigger);

    Livewire.on('complexesLoaded', ({ html, finished }) => {
        isLoading = false;
        if (loader) loader.style.display = 'none';

        if (html && loader) {
            loader.insertAdjacentHTML('beforebegin', html);
        }

        if (finished) {
            observer.disconnect();
            return;
        }

        // If trigger is still visible, load next batch immediately
        const rect = trigger.getBoundingClientRect();
        if (rect.top < window.innerHeight + 500) {
            loadNext();
        }
    });
});
